import { Box44FieldNames } from './types';

export const h1PathBox44 = 'goodsShipment.producedDocumentsWritingOff';
export const h1PathBox44Products = 'producedDocumentsWritingOff';
export const h1Box44KeyNames: Box44FieldNames = {
    documentType: 'documentType',
    documentIdentifier: 'documentIdentifier',
    monetaryAmount: 'currency',
    measurement: 'measurementUnitAndQualifier',
};
export const h7PathBox44 = 'goodsShipment.documentsAuthorisations.supportingDocument';
export const h7PathBox44Products = 'documentsAuthorisations.supportingDocument';
export const h7Box44KeyNames: Box44FieldNames = {
    documentType: 'supportingDocumentType',
    documentIdentifier: 'supportingDocumentReferenceNumber',
    monetaryAmount: 'currency',
    measurement: 'measurementUnitAndQualifier',
};

export const ensPathBox44Products = 'additionalDocument';
export const ensBox44KeyNames: Box44FieldNames = {
    documentType: 'code',
    documentIdentifier: 'identifier',
};

export const box44PathAndFieldNames: Record<string, any> = {
    ...['H1', 'H2', 'H3', 'H4', 'H5', 'H6', 'I1'].reduce((acc, curr) => {
        acc[curr] = {
            masterPath: h1PathBox44,
            productPath: h1PathBox44Products,
            documentTypeName: h1Box44KeyNames.documentType,
            documentIdentifierName: h1Box44KeyNames.documentIdentifier,
            monetaryAmountName: h1Box44KeyNames.monetaryAmount,
            measurementName: h1Box44KeyNames.measurement,
        };
        return acc;
    }, {} as any),
    H7: {
        masterPath: h7PathBox44,
        productPath: h7PathBox44Products,
        documentTypeName: h7Box44KeyNames.documentType,
        documentIdentifierName: h7Box44KeyNames.documentIdentifier,
        monetaryAmountName: h1Box44KeyNames.monetaryAmount,
        measurementName: h1Box44KeyNames.measurement,
    },
    ENS: {
        masterPath: 'stringSoItDoesntGiveAnError',
        productPath: ensPathBox44Products,
        documentTypeName: ensBox44KeyNames.documentType,
        documentIdentifierName: ensBox44KeyNames.documentIdentifier,
    },
    F11: {
        // TODO: Will be updated in a follow-up work item
        masterPath: 'masterPath',
        productPath: 'productPath',
        houseConsignmentPath: 'houseConsignmentPath',
        documentTypeName: 'documentTypeName',
        documentIdentifierName: 'documentIdentifierName',
    },
    F50: {
        // TODO: Will be updated in a follow-up work item
        masterPath: 'masterPath',
        productPath: 'productPath',
        houseConsignmentPath: 'houseConsignmentPath',
        documentTypeName: 'documentTypeName',
        documentIdentifierName: 'documentIdentifierName',
    },
};
